/** A retiring popup must not reclaim focus from the control opened after it. */
export function preserveMovedPickerFocus(event: Event) {
  const focused = document.activeElement;
  if (
    focused &&
    focused !== document.body &&
    event.target instanceof HTMLElement &&
    !event.target.contains(focused)
  ) {
    event.preventDefault();
  }
}
